import MicroModal from 'micromodal'
import axios from 'axios'
const prod = process.env.NODE_ENV === 'production';

export default class BuyLink {
    constructor(el) {
        this.el = el;
        this.vars();
        this.init();
    }
    vars() {
        this.group = this.el.dataset.groupCapable
        this.type = this.el.dataset.type
        this.id = this.el.dataset.id
        this.modal = document.querySelector('[data-group-modal]')
        this.url = this.el.href;
        this.resultSelector = '[data-ask-if-group]';
        this.modalTarget = document.querySelector('[data-modal-target]')
    }
    init() {
        this.el.addEventListener('click',this.handleClick)
    }

    handleClick =(event) => {
        if(this.group === 'true') {
            event.preventDefault()
            this.handleLoadModal()
            console.log(event)
        }
    }
    handleGroup() {
        if(typeof this.group || this.group === false) {
            return false;
        }
        this.handleLoadModal()
    }

    handleLoadModal = () => {
        this.modalTarget.innerHTML = '';
        axios
            .get(this.url)
            .then(({ data }) => {
                this.appendResult(data)
            })
            .catch(error => {
                if(prod) {
                    window.location = this.url
                } else {
                    console.log(error);
                }
            })
            .then(() => {
                MicroModal.show('modal-1');
            })
    }

    appendResult = body => {
        // Get nodelist of new results
        const tempBody = document.createElement('div')
        tempBody.innerHTML = body
        const result = tempBody.querySelector(this.resultSelector)

        // Append new results
        this.modalTarget.innerHTML = '';
        this.modalTarget.appendChild(result)
    }

}